import React from 'react'
import styled from 'styled-components'
import { Box, Text } from 'components'
import { size } from 'utils/responsive'
import ApiKeys from './ApiKeys'
import ApiDocumentation from './ApiDocView/ApiDocumentation'

export const ExternalApiKeys: React.FC = () => (
  <Box p="2rem 2rem 0 2rem">
    <Text fontSize={22} fontWeight="bold" lineHeight="25px" mb={16}>
      external_api_key_title
    </Text>
    <Container>
      <ApiKeys />
    </Container>
  </Box>
)

export const ExternalApiDocumentation: React.FC = () => (
  <Box p="2rem 0 0 2rem">
    <Text fontSize={22} fontWeight="bold" lineHeight="25px" mb={16}>
      external_api_doc_title
    </Text>
    <Container>
      <ApiDocumentation />
    </Container>
  </Box>
)

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  @media only screen and (max-width: ${`${size.medium}px`}) {
    flex-direction: column;
  }
`
